export default __webpack_public_path__ + "static/media/Without_Heatmap.6212f09f.jpg";